import React from 'react';
import { connect } from 'react-redux';

class PauseOverlay extends React.Component {
    isPaused = () => {
        const {gameInfo} = this.props;
        return gameInfo.isPaused;
    };

    render() {
        if(this.isPaused()) {
            return <div id="gameplayer-pause-overlay" />
        }
        return (
            <></>
        );
    }
}

const mapStateToProps = state => ({
    gameInfo: state.gameInfo
});

export default connect(
    mapStateToProps
)(PauseOverlay);
